import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['FeatureReviews'] });

const apiFeatureReviewsSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getFeatureReviews: builder.query({
      query: (ean) => `/community/products/${ean}/features/`,
      providesTags: ['FeatureReviews'],
    }),
    getPersonalFeatureReviews: builder.query({
      query: (ean) => `/community/products/${ean}/features/mine/`,
      providesTags: ['FeatureReviews'],
    }),
    updateFeatureReview: builder.mutation({
      query: ({ payload, ean }) => ({
        url: `/community/products/${ean}/features/mine/`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['FeatureReviews'],
    }),
    deleteFeatureReview: builder.mutation({
      query: ({ ean }) => ({
        url: `/community/products/${ean}/features/mine/`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['FeatureReviews'],
    }),
  }),
});

export const { useGetFeatureReviewsQuery, useGetPersonalFeatureReviewsQuery, useUpdateFeatureReviewMutation, useDeleteFeatureReviewMutation } = apiFeatureReviewsSlice;

export default apiFeatureReviewsSlice;
